module.exports = __webpack_public_path__ + "static/media/clouds.5e84ff4e.png";